import { Extra } from '@common/components/Extras';
import { ExtrasCategoryTitle } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/ExtrasCategoryTitle';
import { useWatch } from 'react-hook-form';
import { MultiRoomSearch } from 'shared-types';
import { RoomExtra, RoomExtraOption } from 'shared-types/Room';
import { Options } from './Options/Options';
import { MultiRoomPerStay } from './PerStay/MultiRoomPerStay';
import { PerStay } from './PerStay/PerStay';

type ExtrasProps = {
  extras?: RoomExtra[] | null;
  isMultiRoom: boolean;
  rooms?: MultiRoomSearch;
};

export const Extras = ({ extras, isMultiRoom, rooms = [] }: ExtrasProps) => {
  const extrasValues = useWatch({ name: 'extras' }) ?? [];

  return (
    <>
      {extras &&
        extras.map((extra, index) => {
          const extraValues = Array.isArray(extrasValues) ? extrasValues[index] : undefined;
          const isSelected = extraValues?.isSelected;
          const selectedOptionIndex = extraValues?.option;
          const selectedExtraOption =
            'options' in extra
              ? (extra.options?.[selectedOptionIndex] as RoomExtraOption | undefined)
              : undefined;

          return (
            <div key={extra.id ?? index}>
              <ExtrasCategoryTitle extras={extras} index={index} />
              <Extra
                featured
                showPrice
                controls={(() => {
                  switch (extra.type) {
                    case 'per_stay': {
                      return isMultiRoom ? (
                        <MultiRoomPerStay
                          id={index}
                          maxQuantity={extra.maxQuantity}
                          pricingType={extra.pricingType ?? 'per_stay'}
                          rooms={rooms}
                        />
                      ) : (
                        <PerStay id={index} maxQuantity={extra.maxQuantity} />
                      );
                    }
                    default: {
                      return <Options {...extra} selectedOption={selectedExtraOption} id={index} />;
                    }
                  }
                })()}
                isSelected={isSelected}
                {...(extra as any)}
              />
            </div>
          );
        })}
    </>
  );
};
